export const catalogColors = {
  infoBlue:   '#3B82F6',  // in-feed segment, queue, review-queue
  accentTeal: '#0E9D8A',  // canonical / manifest / AEO generated
  accentDark: '#0B7A6A',  // approved
  purple:     '#8A6DF0',  // translations / live on site
  warn:       '#F97316',  // failures / rejected / live-gap
  amber:      '#F59E0B',  // awaiting / quality-flagged
  gray:       '#9CA3AF',  // other / unknown / out-of-scope
  muted:      '#E5E7EB',  // empty bar track (light, not bg-muted)
} as const;

export type CatalogColorKey = keyof typeof catalogColors;
